import { render, staticRenderFns } from "./GMBAudit.vue?vue&type=template&id=6f0887c2"
import script from "./GMBAudit.vue?vue&type=script&lang=js"
export * from "./GMBAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports